export const localFormat = 'JPEG';
export const cameraOnlyFormat = 'image/jpeg';
export const maxImageSize = 2500;
export const maxQuality = 70;
